import zoomInMapIcon from '@atom/components/common/svgIcons/zoomInMapIcon.svg';
import { Tooltip } from '@atom/mui';

import classes from './taskMapRecenterControl.module.css';

type TaskMapRecenterControlProps = {
  onClick: () => void;
};

const TaskMapRecenterControl = ({ onClick }: TaskMapRecenterControlProps) => (
  <Tooltip title="Center" placement="bottom-start">
    <div
      className={classes.recenterControl}
      onClick={onClick}
      data-cy="taskMapRecenter"
    >
      <img src={zoomInMapIcon} alt="" />
    </div>
  </Tooltip>
);

export default TaskMapRecenterControl;
